import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'

import { Translation } from 'cng-common/features/translations'
import { Card } from 'partner360/components/card'
import { MANAGER_COCKPIT_TOUR_TARGETS as TOUR_TARGETS } from 'partner360/configs/widgetTour/managerCockpitTourTargets'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../configs/translations'
import { resetCockpitFilter } from '../../model'
import { useCockpitFilterInitialization } from '../../model/hooks/useCockpitFilterInitialization'
import { useCockpitPartnersShown } from '../../model/hooks/useCockpitPartnersShown'
import { CockpitRtm } from '../cockpitRtm/CockpitRtm'
import { CockpitExpandButton } from '../components/cockpitExpandButton'
import { CockpitTableRowTitle } from '../components/cockpitTableTitle'

import { CockpitFilterOptions } from './components/cockpitFilterOptions/CockpitFilterOptions'

import styles from './CockpitUnifiedFilterPanel.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.filterPanel

export const CockpitUnifiedFilterPanel = () => {
  const dispatch = useAppDispatch()
  const { shownCount, totalCount, textKey } = useCockpitPartnersShown()
  useCockpitFilterInitialization()

  return (
    <Card as="aside" bare hoverable={false} className={styles.root}>
      <header className={styles.header}>
        <CockpitTableRowTitle className={styles.title}>
          <Translation span text={KEYS.title} />
        </CockpitTableRowTitle>
        <CockpitExpandButton
          className={styles.clear}
          onClick={() => dispatch(resetCockpitFilter())}
        >
          <Translation span text={KEYS.clearAll} />
        </CockpitExpandButton>
      </header>
      <div className={styles.scope}>
        <CockpitRtm embedded />
        <div className={styles.summary}>
          <Translation
            span
            text={textKey}
            replaceParams={[
              { key: '{count}', value: `<strong>${shownCount}</strong>` },
              { key: '{totalCount}', value: String(totalCount) },
            ]}
          />
        </div>
      </div>
      <div className={styles.content} data-tour-id={TOUR_TARGETS.filterOptions}>
        <CockpitFilterOptions unified />
      </div>
    </Card>
  )
}
